import { render, staticRenderFns } from "./Clothing.vue?vue&type=template&id=3e2d5bd4&scoped=true&"
import script from "./Clothing.vue?vue&type=script&lang=js&"
export * from "./Clothing.vue?vue&type=script&lang=js&"
import style0 from "./Clothing.vue?vue&type=style&index=0&id=3e2d5bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d5bd4",
  null
  
)

export default component.exports